/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum RemarkType {
  VirtualContainerInfo = 'VirtualContainerInfo',
  ProductionOrderInfoPL = 'ProductionOrderInfoPL',
  ProductionJobInfoPL = 'ProductionJobInfoPL',
  ProductionOrderInfoShopFloor = 'ProductionOrderInfoShopFloor',
  ProductionKpiInfo = 'ProductionKpiInfo',
  ShiftReportInfo = 'ShiftReportInfo'
}
